import logo from "./logo_dic.png";
import "./App.css";
import Dictionary from "./Dictionary";

export default function App() {
  return (
    <div className="App-wlcome">
      <section className="header">
        <h1 className="welcome">
          {" "}
          Welcome to
          <br /> Visualpedia
        </h1>
        <header className="App-header">
          {" "}
          <img src={logo} className="App-logo img-fluid" alt="logo" />
        </header>
      </section>
      <div className="App">
        <main>
          <Dictionary defaultKeyword="beach" />
        </main>
        <footer className="App-footer">
          <small>
            This project was coded by Muriel Cishek, <br />
            <a
              href="https://github.com/Murielcibra/dictionary-project"
              target="_blank"
              rel="noreferrer"
            >
              open source on Github
            </a>{" "}
            and{" "}
            <a
              href="https://playful-sundae-2825b0.netlify.app/"
              target="_blank"
              rel="noreferrer"
            >
              hosted on Nelify
            </a>
          </small>
        </footer>
      </div>
    </div>
  );
}
